export default {"id":"4f376e8f","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}